module.exports = __webpack_public_path__ + "static/media/message-no-shadow.942fe1ea.png";